var map = {
	"./arrows/arrow-down-simple.svg": 9916,
	"./arrows/arrow-down.svg": 5890,
	"./arrows/arrow-left.svg": 4528,
	"./arrows/arrow-right.svg": 7631,
	"./arrows/arrow-top.svg": 9988,
	"./arrows/slider-arrow-left.svg": 7202,
	"./arrows/slider-arrow-right.svg": 9176,
	"./main/attention.svg": 3591,
	"./main/cart.svg": 8831,
	"./main/category.svg": 2114,
	"./main/check.svg": 8120,
	"./main/close-alt.svg": 3775,
	"./main/close.svg": 9016,
	"./main/consultant.svg": 3426,
	"./main/cross.svg": 1209,
	"./main/delivery.svg": 4055,
	"./main/email.svg": 8205,
	"./main/filters.svg": 5458,
	"./main/logo-monocolor.svg": 4858,
	"./main/logo.svg": 1045,
	"./main/magnifier.svg": 5325,
	"./main/measure.svg": 6464,
	"./main/phone.svg": 152,
	"./main/rating.svg": 5323,
	"./main/remove.svg": 141,
	"./main/sort.svg": 7476,
	"./main/tools.svg": 9072,
	"./main/truck.svg": 8677,
	"./main/window.svg": 433,
	"./social/icon-wa.svg": 4391
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5818;